import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { 
  FiHome, FiInfo, FiBook, FiCalendar, FiAward, FiUsers, 
  FiCheckCircle, FiArrowRight, FiFileText, FiPhone, FiMail,
  FiMapPin, FiClock, FiDownload, FiLogIn, FiMenu, FiX
} from 'react-icons/fi';
import { toast } from 'react-toastify';
import './BerandaPMB.css';

const BerandaPMB = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('beranda');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    fetchPages();
  }, []);

  const fetchPages = async () => {
    try {
      const res = await axios.get('/api/pmb/halaman/public');
      console.log('Fetched pages:', res.data);
      setPages(res.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching pages:', error);
      console.error('Error response:', error.response);
      toast.error('Gagal memuat data halaman: ' + (error.response?.data?.message || error.message));
      setLoading(false);
      // Fallback to empty array on error
      setPages([]);
    }
  };

  const menuPages = pages.filter(p => p.is_published).sort((a, b) => a.display_order - b.display_order);
  
  console.log('All pages:', pages);
  console.log('Published pages for menu:', menuPages);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const programStudi = [
    {
      name: 'Profesi Ners',
      description: 'Program profesi untuk menjadi perawat profesional',
      duration: '1-2 Tahun',
      degree: 'Ners',
      icon: <FiUsers />
    },
    {
      name: 'S1 Keperawatan',
      description: 'Program sarjana keperawatan berkualitas',
      duration: '4 Tahun',
      degree: 'S.Kep',
      icon: <FiAward />
    },
    {
      name: 'S1 Kesehatan Masyarakat',
      description: 'Program kesehatan masyarakat terapan',
      duration: '4 Tahun',
      degree: 'S.K.M',
      icon: <FiBook />
    }
  ];

  const jalurPendaftaran = [
    {
      title: 'Reguler',
      description: 'Jalur penerimaan mahasiswa baru reguler',
      kuota: '100 Kursi',
      biaya: 'Rp 15.000.000',
      icon: <FiCheckCircle />,
      color: '#667eea'
    },
    {
      title: 'RPL Transfer',
      description: 'Rekognisi Pembelajaran Lampau - Transfer',
      kuota: '15 Kursi',
      biaya: 'Rp 10.000.000',
      icon: <FiFileText />,
      color: '#f59e0b'
    },
    {
      title: 'RPL Perolehan',
      description: 'Rekognisi Pembelajaran Lampau - Perolehan',
      kuota: '10 Kursi',
      biaya: 'Rp 8.000.000',
      icon: <FiBook />,
      color: '#84a95bff'
    },
    {
      title: 'Beasiswa',
      description: 'Pendaftaran dengan beasiswa khusus',
      kuota: '10 Kursi',
      biaya: 'Rp 8.000.000',
      icon: <FiAward />,
      color: '#2973a0ff'
    }
  ];

  const timeline = [
    { phase: 'Pendaftaran Online', date: '1 Nov - 31 Des 2025', status: 'active' },
    { phase: 'Seleksi Berkas', date: '1 - 15 Jan 2026', status: 'upcoming' },
    { phase: 'Tes Tertulis & Wawancara', date: '20 - 25 Jan 2026', status: 'upcoming' },
    { phase: 'Pengumuman Hasil', date: '1 Feb 2026', status: 'upcoming' },
    { phase: 'Daftar Ulang', date: '5 - 15 Feb 2026', status: 'upcoming' }
  ];

  const faqs = [
    {
      question: 'Kapan pendaftaran dibuka?',
      answer: 'Pendaftaran dibuka mulai 1 November 2025 hingga 31 Desember 2025.'
    },
    {
      question: 'Apa saja persyaratan pendaftaran?',
      answer: 'Ijazah SMA/SMK, Transkrip Nilai, Foto, KTP, Kartu Keluarga, dan dokumen pendukung lainnya.'
    },
    {
      question: 'Berapa biaya pendaftaran?',
      answer: 'Biaya pendaftaran hanya sebesar Rp 100.000 (non-refundable).'
    },
    {
      question: 'Bagaimana cara mendaftar?',
      answer: 'Pendaftaran dilakukan secara online melalui website PMB kami. Ikuti petunjuk pendaftaran yang tersedia.'
    }
  ];

  if (loading) {
    return <div className="spinner"></div>;
  }

  return (
    <div className="beranda-pmb">
      {/* Header/Navigation */}
      <header className="pmb-header">
        <div className="pmb-container">
          <div className="pmb-nav">

            {/* Logo always left, menu always right, hamburger only visible on mobile */}
            <div className="pmb-logo">
              <div className="logo-text">
                <h1>PMB 2026</h1>
                {!isMobile && <p>Penerimaan Mahasiswa Baru</p>}
              </div>
              <img 
                src="/images/logo-stikes.png" 
                alt="Logo STIKES" 
                className="logo-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.previousSibling.style.marginLeft = '0';
                }}
              />
            </div>

            {/* Hamburger menu toggle, only visible on mobile */}
            {isMobile && (
              <button 
                className="mobile-menu-toggle" 
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? <FiX /> : <FiMenu />}
              </button>
            )}

            {/* Desktop & Mobile Menu */}
            <nav className={`pmb-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <a 
                href="#beranda" 
                className={activeTab === 'beranda' ? 'active' : ''}
                onClick={() => {
                  setActiveTab('beranda');
                  closeMobileMenu();
                }}
              >
                <FiHome /> Beranda
              </a>
              {loading ? (
                <span style={{ padding: '10px', color: '#999' }}>Memuat menu...</span>
              ) : menuPages.length > 0 ? (
                menuPages.map(page => (
                  <a 
                    key={page._id}
                    href={`#${page.page_slug}`}
                    onClick={() => {
                      setActiveTab(page.page_slug);
                      closeMobileMenu();
                    }}
                    className={activeTab === page.page_slug ? 'active' : ''}
                  >
                    {page.page_type === 'informasi' && <FiInfo />}
                    {page.page_type === 'prosedur' && <FiFileText />}
                    {page.page_type === 'pengumuman' && <FiCalendar />}
                    {page.page_type === 'berita' && <FiBook />}
                    {page.page_title}
                  </a>
                ))
              ) : (
                <span style={{ padding: '10px', color: '#999', fontSize: '12px' }}>
                  Tidak ada halaman tersedia
                </span>
              )}
              <Link 
                to="/pmb/login" 
                className="btn-login"
                onClick={closeMobileMenu}
              >
                <FiLogIn /> Daftar
              </Link>
            </nav>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && (
          <div 
            className="mobile-menu-overlay" 
            onClick={closeMobileMenu}
          ></div>
        )}
      </header>

      {/* Hero Section */}
      <section className="pmb-hero">
        <div className="hero-background">
          <div className="hero-pattern"></div>
        </div>
        <div className="pmb-container">
          <div className="hero-content">
            <h1 className="hero-title">
              Selamat Datang di<br />
              <span className="gradient-text">Penerimaan Mahasiswa Baru 2026</span>
            </h1>
            <p className="hero-subtitle">
              Wujudkan impian Anda menjadi tenaga kesehatan profesional.<br />
              Bergabunglah bersama kami dan raih masa depan cerah!
            </p>
            <div className="hero-buttons">
              <Link to="/pmb/register" className="btn btn-primary-large">
                <FiCheckCircle /> Daftar Sekarang
              </Link>
              <a href="#program" className="btn btn-outline-large">
                <FiBook /> Lihat Program Studi
              </a>
            </div>
            <div className="hero-stats">
              <div className="stat-item">
                <h3>1000+</h3>
                <p>Alumni Sukses</p>
              </div>
              <div className="stat-item">
                <h3>50+</h3>
                <p>Dosen Berpengalaman</p>
              </div>
              <div className="stat-item">
                <h3>95%</h3>
                <p>Tingkat Kelulusan</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dynamic Pages Content Sections */}
      {menuPages.length > 0 && menuPages.map((page) => (
        <section key={page._id} id={page.page_slug} className="pmb-section page-content-section">
          <div className="pmb-container">
            <div className="page-content-wrapper">
              {page.banner_image && (
                <div className="page-banner">
                  <img src={page.banner_image} alt={page.page_title} />
                </div>
              )}
              <div className="page-header">
                <span className="page-type-badge">
                  {page.page_type === 'informasi' && <><FiInfo /> Informasi</>}
                  {page.page_type === 'prosedur' && <><FiFileText /> Prosedur</>}
                  {page.page_type === 'pengumuman' && <><FiCalendar /> Pengumuman</>}
                  {page.page_type === 'berita' && <><FiBook /> Berita</>}
                  {page.page_type === 'static' && <><FiHome /> Halaman</>}
                </span>
                <h2>{page.page_title}</h2>
                {page.meta_description && (
                  <p className="page-meta-description">{page.meta_description}</p>
                )}
              </div>
              <div 
                className="page-html-content"
                dangerouslySetInnerHTML={{ __html: page.page_content }}
              />
            </div>
          </div>
        </section>
      ))}

      {/* Program Studi Section */}
      <section id="program" className="pmb-section">
        <div className="pmb-container">
          <div className="section-header">
            <h2>Program Studi</h2>
            <p>Pilih program studi sesuai minat dan bakat Anda</p>
          </div>
          <div className="program-grid">
            {programStudi.map((program, index) => (
              <div key={index} className="program-card">
                <div className="program-icon">{program.icon}</div>
                <h3>{program.name}</h3>
                <p>{program.description}</p>
                <div className="program-details">
                  <div className="detail-item">
                    <FiClock />
                    <span>{program.duration}</span>
                  </div>
                  <div className="detail-item">
                    <FiAward />
                    <span>{program.degree}</span>
                  </div>
                </div>
                <Link to="/pmb/register" className="btn-program">
                  Daftar Program <FiArrowRight />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Jalur Pendaftaran Section */}
      <section className="pmb-section bg-light">
        <div className="pmb-container">
          <div className="section-header">
            <h2>Jalur Pendaftaran</h2>
            <p>Pilih jalur pendaftaran yang sesuai dengan latar belakang Anda</p>
          </div>
          <div className="jalur-grid">
            {jalurPendaftaran.map((jalur, index) => (
              <div key={index} className="jalur-card">
                <div className="jalur-icon" style={{ background: jalur.color }}>
                  {jalur.icon}
                </div>
                <h3>{jalur.title}</h3>
                <p>{jalur.description}</p>
                <div className="jalur-info">
                  </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="pmb-section">
        <div className="pmb-container">
          <div className="section-header">
            <h2>Timeline Pendaftaran</h2>
            <p>Jadwal dan tahapan penerimaan mahasiswa baru</p>
          </div>
          <div className="timeline">
            {timeline.map((item, index) => (
              <div key={index} className={`timeline-item ${item.status}`}>
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  <h4>{item.phase}</h4>
                  <p>{item.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="pmb-section bg-light">
        <div className="pmb-container">
          <div className="section-header">
            <h2>Pertanyaan yang Sering Diajukan</h2>
            <p>Temukan jawaban atas pertanyaan Anda</p>
          </div>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-card">
                <h4>{faq.question}</h4>
                <p>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="pmb-cta">
        <div className="pmb-container">
          <div className="cta-content">
            <h2>Siap Bergabung dengan Kami?</h2>
            <p>Daftarkan diri Anda sekarang dan mulai perjalanan menuju kesuksesan!</p>
            <Link to="/pmb/register" className="btn btn-primary-large">
              <FiCheckCircle /> Daftar Sekarang
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="pmb-section">
        <div className="pmb-container">
          <div className="section-header">
            <h2>Hubungi Kami</h2>
            <p>Butuh bantuan? Kami siap membantu Anda</p>
          </div>
          <div className="contact-grid">
            <div className="contact-card">
              <FiPhone />
              <h4>Telepon</h4>
              <p>+62 21 1234 5678</p>
            </div>
            <div className="contact-card">
              <FiMail />
              <h4>Email</h4>
              <p>pmb@kampus.ac.id</p>
            </div>
            <div className="contact-card">
              <FiMapPin />
              <h4>Alamat</h4>
              <p>Jl. Pendidikan No. 123, Jakarta</p>
            </div>
            <div className="contact-card">
              <FiClock />
              <h4>Jam Layanan</h4>
              <p>Senin - Jumat, 08:00 - 16:00</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="pmb-footer">
        <div className="pmb-container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>PMB 2026</h3>
              <p>Penerimaan Mahasiswa Baru</p>
              <p>Sekolah Tinggi Ilmu Kesehatan Baramuli</p>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#beranda">Beranda</a></li>
                <li><a href="#program">Program Studi</a></li>
                <li><Link to="/pmb/register">Pendaftaran</Link></li>
                <li><Link to="/pmb/login">Login</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Informasi</h4>
              <ul>
                {menuPages.slice(0, 4).map(page => (
                  <li key={page._id}>
                    <a href={`#${page.page_slug}`}>{page.page_title}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="footer-section">
              <h4>Download</h4>
              <ul>
                <li><a href="/downloads/brosur.pdf" target="_blank" rel="noopener noreferrer"><FiDownload /> Brosur PMB</a></li>
                <li><a href="/downloads/panduan.pdf" target="_blank" rel="noopener noreferrer"><FiDownload /> Panduan Pendaftaran</a></li>
                <li><a href="/downloads/form.pdf" target="_blank" rel="noopener noreferrer"><FiDownload /> Form Pendaftaran</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 PMB Universitas Kesehatan. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BerandaPMB;
